<mat-form-field *ngIf="initialized" style="width: 100%;" [attr.fieldReadOnly]="field.readonly === true">
  <mat-label>{{field.title}}</mat-label>
  <input type="text"
         (blur)="onBlurHandler()"
         matInput
         [formControl]="formControl"
         [matAutocomplete]="auto"
         [readonly]="field.readonly">
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="getDisplayValue">
    <mat-option *ngFor="let option of filtered$ | async" [value]="option">
      {{option[observableField.optionName]}}
    </mat-option>
  </mat-autocomplete>
  <mat-error>{{errorMessage}}</mat-error>
</mat-form-field>
